import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=f1381814&scoped=true"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=f1381814&prod&lang=scss"
import style1 from "./DefaultTemplate.vue?vue&type=style&index=1&id=f1381814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1381814",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F04-templates%2Fdefault%2FDefaultTemplate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports